document.addEventListener('DOMContentLoaded', function() {
  // Categories sidebar
  const sidebar = document.getElementById('blogCategoriesSidebar');
  const overlay = document.getElementById('blogCategoriesSidebarOverlay');
  const openBtn = document.getElementById('blogCategoriesSidebarOpen');
  const closeBtn = document.getElementById('blogCategoriesSidebarClose');

  // Right sidebar
  const rightSidebar = document.getElementById('blogRightSidebar');
  const rightOverlay = document.getElementById('blogRightSidebarOverlay');
  const rightOpenBtn = document.getElementById('blogHeaderHamburger');
  const rightCloseBtn = document.getElementById('blogRightSidebarClose');

  function openSidebar() {
    // Close right sidebar if open
    closeRightSidebar();
    
    sidebar.classList.add('open');
    overlay.classList.add('open');
    sidebar.focus();
    document.body.style.overflow = 'hidden';
  }

  function closeSidebar() {
    sidebar.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function openRightSidebar() {
    // Close categories sidebar if open
    closeSidebar();
    
    rightSidebar.classList.add('open');
    rightOverlay.classList.add('open');
    rightSidebar.focus();
    document.body.style.overflow = 'hidden';
  }

  function closeRightSidebar() {
    rightSidebar.classList.remove('open');
    rightOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (openBtn && closeBtn && overlay && sidebar) {
    openBtn.addEventListener('click', openSidebar);
    closeBtn.addEventListener('click', closeSidebar);
    overlay.addEventListener('click', closeSidebar);
    sidebar.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeSidebar();
    });
  }

  if (rightOpenBtn && rightCloseBtn && rightOverlay && rightSidebar) {
    rightOpenBtn.addEventListener('click', openRightSidebar);
    rightCloseBtn.addEventListener('click', closeRightSidebar);
    rightOverlay.addEventListener('click', closeRightSidebar);
    rightSidebar.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeRightSidebar();
    });
  }
}); 